import styled from 'styled-components';

import { colors } from '../../constants/styleConstants';

const RowContainer = styled.div`
  align-items: center;
  background-color: ${colors.lightGrey};
  color: ${colors.darkGrey};
  display: flex;
  flex-flow: row nowrap;
  font-size: 1.6em;
  margin-bottom: 1rem;
  height: 4.5rem;
`;

export default RowContainer;



// WEBPACK FOOTER //
// ./src/components/common/RowContainer.js